const confirmSettlementsTableCopy = {
  tableHeaderActiveSettlements: 'Active Settlements',
  tableHeaderCompletedSettlements: 'Completed Settlements'
};

export default confirmSettlementsTableCopy;
